import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);// triggers every time the URL path changes
  }, [pathname]);

  return null; // component doesn't render anything visually
};

export default ScrollToTop;